// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_wrapper__iyRON {
  min-width: 400px;
  max-height: calc(100vh - 100px);
  min-height: -moz-fit-content;
  min-height: fit-content;
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: 16px;
}
@media (max-width: 768px) {
  .styles_wrapper__iyRON {
    min-width: auto;
    width: calc(100vw - 120px);
  }
}

.styles_headingWrapper__cxeCR {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.styles_headingText__\\+MKq0 {
  font-weight: 800;
  font-size: 24px;
  line-height: 30px;
  letter-spacing: -0.015em;
  text-transform: capitalize;
  color: #ffffff;
}
@media (max-width: 768px) {
  .styles_headingText__\\+MKq0 {
    font-size: 18px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/modalWrapper/styles.module.scss","webpack://./src/assets/styles/mixin/breakpoints.scss","webpack://./src/assets/styles/variables/colors.scss"],"names":[],"mappings":"AAGA;EACE,gBAAA;EACA,+BAAA;EACA,4BAAA;EAAA,uBAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AAFF;ACuBE;ED5BF;IAUI,eAAA;IACA,0BAAA;EADF;AACF;;AAIA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;AADF;;AAIA;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,wBAAA;EACA,0BAAA;EACA,cE9BM;AF6BR;ACEE;EDPF;IASI,eAAA;EAAF;AACF","sourcesContent":["@import './src/assets/styles/variables/colors';\n@import './src/assets/styles/mixin/breakpoints';\n\n.wrapper {\n  min-width: 400px;\n  max-height: calc(100vh - 100px);\n  min-height: fit-content;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n\n  @include md {\n    min-width: auto;\n    width: calc(100vw - 120px);\n  }\n}\n\n.headingWrapper {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.headingText {\n  font-weight: 800;\n  font-size: 24px;\n  line-height: 30px;\n  letter-spacing: -0.015em;\n  text-transform: capitalize;\n  color: $white;\n\n  @include md {\n    font-size: 18px;\n  }\n}\n","@mixin xxxxl {\n  @media (max-width: 1920px) {\n    @content;\n  }\n}\n\n@mixin xxxl {\n  @media (max-width: 1700px) {\n    @content;\n  }\n}\n\n@mixin xxl {\n  @media (max-width: 1400px) {\n    @content;\n  }\n}\n\n@mixin xl {\n  @media (max-width: 1200px) {\n    @content;\n  }\n}\n\n@mixin lg {\n  @media (max-width: 992px) {\n    @content;\n  }\n}\n\n@mixin md {\n  @media (max-width: 768px) {\n    @content;\n  }\n}\n\n@mixin sm {\n  @media (max-width: 576px) {\n    @content;\n  }\n}\n","$white: #ffffff;\n$white-3: rgba($white, 0.03);\n$white-4: rgba($white, 0.04);\n$white-5: rgba($white, 0.05);\n$white-10: rgba($white, 0.1);\n$white-30: rgba($white, 0.3);\n$white-50: rgba($white, 0.5);\n$white-70: rgba($white, 0.7);\n$white-80: rgba($white, 0.8);\n$white-90: rgba($white, 0.9);\n$pink: #ff136d;\n$pink-10: rgba($pink, 0.1);\n$pink-15: rgba($pink, 0.15);\n$black: #000000;\n$black-5: rgba($black, 0.05);\n$black-15: rgba($black, 0.15);\n$black-26: rgba($black, 0.26);\n$black-30: rgba($black, 0.3);\n$black-70: rgba($black, 0.7);\n$black-87: rgba($black, 0.87);\n$black-bg: #100f0f;\n$black-nav-bg: #080808;\n$black-footer: #0a0a0a;\n$blue: #443de9;\n$blue-btn: #453fd6;\n$blue-btn-15: rgba($blue-btn, 0.15);\n$blue-btn-40: rgba($blue-btn, 0.4);\n$grey-nav: #b6b6b6;\n$grey-input: #414141;\n$orange: #f5b300;\n$orange-5: rgba($orange, 0.05);\n$green: #12bc56;\n$red: #d33030;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `styles_wrapper__iyRON`,
	"headingWrapper": `styles_headingWrapper__cxeCR`,
	"headingText": `styles_headingText__+MKq0`
};
export default ___CSS_LOADER_EXPORT___;
